import { useState } from "react";
import { Play, ArrowRight, Star } from "lucide-react";
import { buildBookingSmsHref } from "../lib/bookingSms";

// ============================================================================
//   TO CHANGE THE VIDEO:
//   1. Set VIDEO_PLATFORM to "vimeo" or "youtube"
//   2. Paste the video ID from the URL:
//        Vimeo:   https://vimeo.com/123456789            →  VIDEO_ID = "123456789"
//        YouTube: https://youtube.com/watch?v=abc123     →  VIDEO_ID = "abc123"
// ============================================================================
const VIDEO_PLATFORM = "vimeo"; // "vimeo" or "youtube"
const VIDEO_ID = "1228749663";  // <. PASTE YOUR VIMEO ID HERE

function buildEmbedUrl() {
  if (!VIDEO_ID) return "";
  if (VIDEO_PLATFORM === "vimeo") {
    return `https://player.vimeo.com/video/${VIDEO_ID}?autoplay=1&title=0&byline=0&portrait=0`;
  }
  return `https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0`;
}

export default function VSLSection() {
  const [playing, setPlaying] = useState(false);
  const hasVideo = VIDEO_ID.length > 0;

  return (
    <section
      id="vsl"
      className="relative py-16 md:py-20 bg-[#0c0119] overflow-hidden"
      data-testid="vsl-section"
    >
      <div className="absolute -top-20 left-1/3 w-[500px] h-[500px] rounded-full bg-jester-purple/15 blur-[140px]" />
      <div className="absolute -bottom-20 right-1/4 w-[400px] h-[400px] rounded-full bg-acid/8 blur-[140px]" />

      <div className="relative max-w-5xl mx-auto px-6 md:px-10">
        {/* Video frame */}
        <div className="relative rounded-3xl overflow-hidden border-2 border-jester/40 shadow-[0_0_80px_rgba(141,57,238,0.35)] aspect-video bg-[#120127]">
          {playing && hasVideo ? (
            <iframe
              src={buildEmbedUrl()}
              title="Jester Werks. Ceramic Coating Mississauga"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
              data-testid="vsl-iframe"
            />
          ) : (
            <button
              onClick={() => hasVideo && setPlaying(true)}
              className="group absolute inset-0 flex items-center justify-center bg-gradient-to-br from-jester-purple/30 via-transparent to-[#120127]"
              data-testid="vsl-play-btn"
              aria-label="Play video"
            >
              <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,transparent_30%,#000_100%)]" />
              <div className="relative flex flex-col items-center gap-4">
                <div className="w-24 h-24 md:w-28 md:h-28 rounded-full bg-acid flex items-center justify-center shadow-[0_0_60px_rgba(168,224,0,0.6)] group-hover:scale-110 transition-transform duration-300">
                  <Play
                    className="w-10 h-10 md:w-12 md:h-12 text-[#120127] ml-1"
                    fill="#120127"
                  />
                </div>
                <div className="text-center">
                  <div className="font-display text-2xl md:text-3xl text-white">
                    {hasVideo ? "Take The Shop Tour" : "Video Coming Soon"}
                  </div>
                  <div className="text-sm text-white/60 mt-1 font-label tracking-[0.2em] uppercase">
                    {hasVideo ? "2 min &middot; Inside our Mississauga bay" : "Filming this week"}
                  </div>
                </div>
              </div>
            </button>
          )}
        </div>

        {/* Big Book Now CTA directly under video */}
        <div className="mt-8 flex flex-col items-center gap-4">
          <a
            href={buildBookingSmsHref()}
            data-testid="vsl-cta"
            className="group inline-flex items-center gap-3 px-10 h-16 rounded-full bg-acid hover:bg-[#bff020] text-[#120127] font-label tracking-[0.2em] text-base uppercase transition-all shadow-[0_0_60px_rgba(168,224,0,0.55)]"
          >
            <span className="font-stencil text-lg">$550</span>
            &middot; Book Now. Text Us
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>

          {/* Trust bar under CTA */}
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 pt-3">
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5" style={{ color: "#FDC814", fill: "#FDC814" }} />
                ))}
              </div>
              <span className="text-xs text-white/70 font-label tracking-[0.15em] uppercase">
                250+ Google reviews
              </span>
            </div>
            <div className="text-xs text-white/50 font-label tracking-[0.15em] uppercase">
              &middot; 1,500+ cars coated
            </div>
            <div className="text-xs text-white/50 font-label tracking-[0.15em] uppercase">
              &middot; 5-year warranty
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
